import { METADATA_TYPE } from './accounts';
import { PARAMETERS } from './global';

//enum
export enum ETAB_NUMBER_SUB_DETAIL {
  SITTERS = 0,
  JOBS = 1,
  PURCHASE_HISTORY = 2,
}

export enum ETAB_TEXT_SUB_DETAIL {
  SITTERS = 'sitters',
  JOBS = 'ac-jobs',
  PURCHASE_HISTORY = 'history',
}

export enum AC_SERVICE_REQUEST_STATUS {
  NEW = 'new',
  CONTACTED = 'contacted',
  SITTER_ADDED = 'sitter_added',
  SITTER_ACCEPTED_BY_PARENT = 'sitter_accepted_by_parent',
  JOB_CREATED = 'job_created',
}

export enum AC_BASE_REQUEST_STATUS {
  PENDING_PAYMENT = 'pending_payment',
  SEARCH_REQUESTED = 'search_requested',
  SEARCH_FOUND = 'search_found',
  PARENT_ACCEPTED = 'parent_accepted',
  TRIAL_CREATED = 'trial_created',
  TRIAL_PAID = 'trial_paid',
  TRIAL_COMPLETED = 'trial_completed',
  PARENT_REJECTED = 'parent_rejected',
  PAYMENT_COMPLETED = 'payment_completed',
  PAYMENT_FAILED = 'payment_failed',
  ACTIVE = 'active',
  CLOSED = 'closed',
}

//interface
export interface PETS {
  cats: boolean;
  dogs: boolean;
}

export interface PARENT {
  profile_picture: string;
  User: USER;
  subscription: SUBSCRIPTION;
}

export interface ADDRESS {
  latitude: number;
  longitude: number;
  id: string;
  parent_id: string;
  sitter_id: any;
  region_id: string;
  name: string;
  block_number: string;
  street: string;
  unit_number: string;
  building_name: any;
  country: string;
  postal_code: string;
  is_default: boolean;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface USER {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
}

export interface SUBSCRIPTION {
  balance: number;
  sitter_rate: number;
  id: string;
  number: string;
  is_trial: boolean;
}

export interface SUBSCRIPTION_TYPE {
  id: string;
  address: ADDRESS;
  parent_id: string;
  number: string;
  start_datetime: Date | string;
  end_datetime: Date;
  days_of_week: number[];
  address_id: string;
  children_ids: string[];
  pets: PETS;
  special_requirements: string;
  status: AC_BASE_REQUEST_STATUS;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  parent: PARENT;
}

export interface SUBSCRIPTION_PARAMS_REQUEST {
  page?: number;
  limit?: number;
  offset?: number;
  search?: string;
  sort?: string;
  status?: string;
}

export interface SUBSCRIPTION_STATE {
  records: SUBSCRIPTION_TYPE[];
  metadata: METADATA_TYPE;
  params?: SUBSCRIPTION_PARAMS_REQUEST | null;
}

//DETAIL

export interface SUBSCRIPTION_DETAIL_TYPE {
  balance: number;
  sitter_rate: number;
  id: string;
  parent_id: string;
  number: string;
  is_trial: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  parent: PARENT_SUBSCRIPTION_DETAIL;
}

export interface PARENT_SUBSCRIPTION_DETAIL {
  profile_picture: string;
  User: USER;
}

//DETAIL BASE REQUEST

export interface CHILDREN {
  id: string;
  full_name: string;
  age_range: number;
  picture: string | null;
  date_of_birth: string;
}

export interface SITTER {
  rating: number;
  hours_worked: number;
  profile_picture: string;
  User: USER;
}

export interface AC_BASE_REQUEST_SITTERS {
  id: string;
  status: string;
  sitter: SITTER;
}

export interface BASE_REQUEST_TYPE {
  id: string;
  parent_id: string;
  number: any;
  start_datetime: Date | string;
  end_datetime: Date;
  days_of_week: number[];
  address_id: string;
  children_ids: string[];
  pets: PETS;
  special_requirements: string;
  status: AC_BASE_REQUEST_STATUS;
  createdAt: string;
  updatedAt: string;
  parent: PARENT;
  ac_base_request_sitters: AC_BASE_REQUEST_SITTERS[];
  address: ADDRESS;
  children: CHILDREN[];
  sitter_rate: number;
  sitter_id?: string;
}

export interface BODY_EDIT_BASE_RAC {
  start_datetime?: string;
  end_datetime?: string;
  days_of_week?: number[];
  address_id?: string;
  children_ids?: string[];
  pets?: PETS;
  special_requirements?: string;
}

//SITTER

export interface SITTER_AC_TYPE {
  years_of_experience: number;
  salary_per_hour: number;
  rating: number;
  hours_worked: number;
  sitter_id: string;
  bio: string;
  profile_picture: string;
  star_sitter_badge: any;
  short_video: any;
  status: string;
  is_push_notification: boolean;
  is_email_notification: boolean;
  is_joined_ac: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  User: USER_SITTER;
  CheckLists: CHECK_LIST[];
}

export interface USER_SITTER {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
}

export interface CHECK_LIST {
  id: string;
  group_name: string;
  name: string;
  type: string;
  order: string;
  createdAt: string;
  updatedAt: string;
}
export interface SITTER_AC_PARAMS_REQUEST {
  id?: string;
  page?: number;
  limit?: number;
  offset?: number;
  search?: string;
  sort?: string;
  filters?: string;
  location?: string;
}

export interface SITTER_AC_STATE {
  data: SITTER_AC_TYPE[];
  metadata: METADATA_TYPE;
  params?: SITTER_AC_PARAMS_REQUEST | null;
}
export interface BODY_ADD_SITTER {
  sitter_ids: string[];
  ac_base_request_id: string;
}

export interface BODY_CHANGE_SITTER {
  sitter_ids: string[];
  ac_base_request_id: string;
}

//jobs

export interface JOB_AC_PROPS {
  sitterRate: number;
  baseRequest: BASE_REQUEST_TYPE | null;
}

export interface PURCHASE_HISTORY_PARAMS_REQUEST extends PARAMETERS {
  parent_id?: string;
  has_balance?: boolean;
}

export interface PURCHASE_HISTORY_STATE {
  records: PURCHASE_HISTORY_ITEM_RESPONSE[];
  metadata: METADATA_TYPE;
  params?: PURCHASE_HISTORY_PARAMS_REQUEST;
}

export interface PURCHASE_HISTORY_ITEM_RESPONSE {
  parent_rate: number;
  sitter_rate: number;
  balance: number;
  id: string;
  parent_id: string;
  package_id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  expiredAt: string;
  package: {
    parent_rate: number;
    sitter_rate: number;
    price: number;
    id: string;
    name: string;
  };
}
